import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as events from '../../store/events'
import * as user from '../../store/user'
import * as onboarding from '../Onboarding/redux/store'

import {onboardingStandaloneOnClose} from '../Onboarding/standaloneUtils'

import '../../../scss/components/_header.scss'

const TBTLogo = () => (
  <div className="c-header-logo" id="onboarding-header__logo">
    <svg
      className="c-header-logo__wordmark c-header-logo__wordmark--desktop"
      id="onboarding-header__wordmark"
    >
      <use xlinkHref="#icon-tbt-logo" />
    </svg>
  </div>
)

const StandaloneOnboardingHeader = ({currentStep, isLoggedIn, hasEventDetails}) => {
  const onCancel = () => onboardingStandaloneOnClose(currentStep, isLoggedIn, hasEventDetails)

  return (
    <header className={classNames('c-header', 'js-header')} id="onboarding-header">
      <TBTLogo />
      <div id="onboarding-header__title">Let’s Set Up Your Event</div>
      <div className="c-header__account">
        <button className="c-header__button" id="onboarding-header__button" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </header>
  )
}

StandaloneOnboardingHeader.propTypes = {
  currentStep: PropTypes.number,
  hasEventDetails: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
}

const mapStateToProps = createStructuredSelector({
  currentStep: onboarding.step,
  hasEventDetails: events.currentEventHasEventDetails,
  isLoggedIn: user.isAuthenticated,
})

export default connect(mapStateToProps)(StandaloneOnboardingHeader)
